<template>
    <div class="d-flex align-center">
        <v-btn
            icon
            color="primary"
            class="mx-2"
            @click="previousMonth"
        >
            <v-icon>mdi-chevron-left</v-icon>
        </v-btn>

        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            left
            max-width="290px"
            min-width="auto"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    color="primary"
                    small
                    outlined
                    v-on="on"
                    style="width: 175px"
                >
                    <v-icon small left>mdi-calendar</v-icon>
                    {{ format(value, "MMMM yyyy") }}
                </v-btn>
            </template>
            <v-date-picker
                v-model="month"
                @input="menu = false"
                type="month"
                scrollable
                color="primary"
            >
            </v-date-picker>
        </v-menu>
<!--        :disabled="canNextMonth"-->
        <v-btn
            icon
            color="primary"
            class="mx-2"
            @click="nextMonth"
        >
            <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
    </div>
</template>

<script>
import {
    addDays, addMonths,
    endOfDay,
    endOfMonth,
    format,
    isMonday, isSameDay, isSameMonth, isSameYear,
    startOfDay,
    startOfMonth,
    subDays,
    subMonths,
    subWeeks
} from "date-fns";
import {mapActions, mapGetters} from "vuex";

const calFmt = (date) => {
    try {
        return format(date, 'yyyy-MM-dd')
    } catch (e) {
        return null;
    }
}

export default {
    props: {
        value: Date
    },
    data() {
        return {
            menu: false,
            format,
        }
    },
    watch: {
        resetDtPicker(val) {
            if (val)
                this.$nextTick(() => {
                    this.resetDtPicker = false
                })
        }

    },
    methods: {
        ...mapActions(['gotoEmployeeSettings', 'gotoDeviceSettings']),

        previousMonth() {
            this.$emit("input", startOfMonth(subMonths(new Date(this.month), 1)))
        },

        nextMonth() {
            this.$emit("input", startOfMonth(addMonths(new Date(this.month), 1)))
        },
    },
    computed: {
        ...mapGetters(['employeesRef', 'devicesByEmployee', "teamsRef", 'access']),

        canNextMonth() {
            return isSameMonth(new Date(), new Date(this.month))
        },

        month: {
            get() {
                return format((this.value || new Date()), "yyyy-MM-dd")
            },
            set(val) {
                this.$emit("input", startOfMonth(new Date(val)))
            }
        }
    },
}
</script>

<style scoped>

</style>